import { Injectable, inject } from '@angular/core';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { format } from 'date-fns';
import { UiFormReactiveConfigService } from '../form-reactive-config.service';

@Injectable({ providedIn: 'root' })
export class InputDateNgbDatepickerI18n extends NgbDatepickerI18n {
  private formReactiveConfigService = inject(UiFormReactiveConfigService);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getWeekdayLabel(weekday: number, width?: Exclude<Intl.DateTimeFormatOptions['weekday'], undefined>): string {
    const weekdaysStartingOnSunday = this.formReactiveConfigService.getWeekDaysStartingOnSunday();

    const weekdays = weekdaysStartingOnSunday.map((day, index) =>
      weekdaysStartingOnSunday[(index + 1) % 7].substring(0, 2),
    );

    return weekdays[weekday - 1] || '';
  }

  getMonthShortName(month: number): string {
    return this.formReactiveConfigService.getMonths()[month - 1].substring(0, 3) || '';
  }

  getMonthFullName(month: number): string {
    return this.formReactiveConfigService.getMonths()[month - 1] || '';
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    const jsDate = new Date(date.year, date.month - 1, date.day);

    return format(jsDate, 'dd-MM-yyyy');
  }
}
